import { render, staticRenderFns } from "./GoodToKnowSection.vue?vue&type=template&id=56b8bb67&scoped=true&"
import script from "./GoodToKnowSection.vue?vue&type=script&lang=js&"
export * from "./GoodToKnowSection.vue?vue&type=script&lang=js&"
import style0 from "./GoodToKnowSection.vue?vue&type=style&index=0&id=56b8bb67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8bb67",
  null
  
)

export default component.exports